import { arrToObj, parseEvent } from '../util';
import {
	SET_CURRENT_EVENT_ID,
	FETCH_EVENTS,
	FETCH_EVENT,
	FETCH_EVENTS_INC_DEL,
	ADD_EVENT,
	UPDATE_EVENT,
	DELETE_EVENT,
	UNDELETE_EVENT,
	UPDATE_EVENT_METADATA,
} from '../actions/actionTypes';
import moment from 'moment';

const preState = {
	events: {},
	currentEvent: {},
};

export const eventReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, eventsIncDel, events, event, event_id, eventMetadata } = action;

	switch (type) {
		case UNDELETE_EVENT:
			if (stateDup.events[event.id]) {
				stateDup.events = {
					...stateDup.events,
					[event.id]: { ...stateDup.events[event.id], deleted_at: null },
				};
			}
			if (event.id === stateDup.currentEvent.id) {
				stateDup.currentEvent = { ...stateDup.currentEvent, deleted_at: null };
			}
			return stateDup;
		case ADD_EVENT:
			stateDup.events = { ...stateDup.events, [event.id]: event };
			return stateDup;
		case DELETE_EVENT: {
			const nowTime = moment().toISOString();
			const archived = { deleted_at: nowTime, updated_at: nowTime };
			if (stateDup.events[event.id]) {
				stateDup.events = {
					...stateDup.events,
					[event.id]: { ...stateDup.events[event.id], ...archived },
				};
			}
			if (event.id === stateDup.currentEvent.id) {
				stateDup.currentEvent = { ...stateDup.currentEvent, ...archived };
			}
			return stateDup;
		}
		case UPDATE_EVENT:
			stateDup.events = {
				...stateDup.events,
				[event.id]: { ...stateDup.events[event.id], ...event },
			};
			if (event.id === stateDup.currentEvent.id) {
				const parsedEvent = parseEvent(stateDup.events[event.id]);
				stateDup.currentEvent = { ...stateDup.currentEvent, ...parsedEvent };
			}
			return stateDup;
		case UPDATE_EVENT_METADATA:
			const eventID = eventMetadata.event_id;
			const eventCopy = stateDup.events[eventID] || {};
			const metadataFieldsCopy = JSON.parse(eventCopy.custom_metadata_fields || '[]');
			const newMetadataFields = metadataFieldsCopy.filter(attr => attr !== eventMetadata.key);
			newMetadataFields.push(eventMetadata.key);
			const metadataAttributesCopy = [...(eventCopy.custom_metadata_attributes || [])];
			const newMetadataAttributes = metadataAttributesCopy.filter(
				attr => attr.key !== eventMetadata.key
			);
			newMetadataAttributes.push(eventMetadata);
			stateDup.events = {
				...stateDup.events,
				[eventID]: {
					...eventCopy,
					custom_metadata_attributes: newMetadataAttributes,
					custom_metadata_fields: JSON.stringify(newMetadataFields),
				},
			};
			if (eventID === stateDup.currentEvent.id) {
				stateDup.currentEvent = {
					...stateDup.currentEvent,
					custom_metadata_attributes: newMetadataAttributes,
					custom_metadata_fields: newMetadataFields,
				};
			}
			return stateDup;
		case FETCH_EVENTS_INC_DEL:
			stateDup.events = arrToObj(eventsIncDel);
			return stateDup;
		case FETCH_EVENTS:
			stateDup.events = arrToObj(events);
			return stateDup;
		case FETCH_EVENT:
			stateDup.events = { ...stateDup.events, [event.id]: event };
			const parsedEvent = parseEvent(event);
			stateDup.currentEvent = { ...parsedEvent };
			return stateDup;
		case SET_CURRENT_EVENT_ID:
			if (!stateDup.currentEvent || event_id !== stateDup.currentEvent.id) {
				stateDup.currentEvent = stateDup.events[event_id]
					? parseEvent(stateDup.events[event_id])
					: {};
			}
			return stateDup;
		default:
			return state;
	}
};

export default eventReducer;
